import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { EmptyState as BaseEmptyState } from '@lyearn/molecules';
import { Stack } from '@lyearn/ui';

function EmptyState({ searchString }: { searchString: string }) {
  const { t } = useTranslation();

  return (
    <Stack className="h-full w-full p-24" direction="col" justifyContent="center">
      {searchString.length ? (
        <BaseEmptyState
          className="pb-80"
          description={t('Skills:AddSkills.NoResultsFound', { searchString })}
          title={t('Skills:AddSkills.NoSkillFound')}
        />
      ) : (
        <BaseEmptyState
          className="pb-80"
          description={t('Skills:AddSkills.NoSkillAvailableDescription')}
          title={t('Skills:AddSkills.NoSkillAvailable')}
        />
      )}
    </Stack>
  );
}

export default EmptyState;
